import { useLocales } from "@/react/story/providers/LocalesContext";
import type { Content } from "@/react/story/types";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";
import TranslationUtils from "@/react/story/utils/TranslationUtils";
import { useId } from "react";

type Props = {
    content: Content;
}

export default function ContentLocalePicker(props: Props) {
    const Locales = useLocales();
    const id = useId();

    const fixedLocales = TranslationUtils.getFixedLocales(Locales.all);
    if (2 > fixedLocales.length) {
        return null;
    }

    return (
        <div style={{ zIndex: 9000 }}>
            <label htmlFor={id} style={{
                display: "block",
                ...TemplatingUtils.style(props.content.config, [ "color", "textAlign", "fontFamily" ]),
            }}>
                {TranslationUtils.get(props.content.config.text, Locales.current)}
            </label>
            <select
                id={id}
                className="form-select text-capitalize"
                value={Locales.current}
                onChange={e => Locales.goto(e.target.value)}
            >
                {fixedLocales.map(l => (
                    <option key={l} value={l} className="text-capitalize">
                        {TranslationUtils.getLocaleName(l)} [{l}]
                    </option>
                ))}
            </select>
        </div>
    );
}
